import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const StyledMultiParticipantsGame = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.wsc.spacing[3]};
`;

export const StyledParticipantsWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "itemsCount",
})<{ itemsCount: number }>`
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(
    ${({ itemsCount }) => itemsCount},
    minmax(0, 1fr)
  );
  gap: ${({ theme }) => theme.wsc.spacing[1]};
`;

export const StyledParticipant = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  padding-right: ${({ theme }) => theme.wsc.spacing[1]};

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.wsc.palette.neutral[500]};
  }
`;

export const StyledParticipantDetails = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.wsc.spacing[0]};
  overflow: hidden;
`;

export const StyledParticipantName = styled(Box)`
  ${({ theme }) => theme.wsc.typography.body1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledParticipantScore = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "isWinner",
})<{ isWinner: boolean }>`
  ${({ theme }) => theme.wsc.typography.body3};
  color: ${({ theme, isWinner }) =>
    isWinner ? theme.wsc.palette.success[100] : theme.wsc.palette.neutral[200]};
`;
